import { useEffect } from 'react';
import { useAppDispatch } from '../../../app/hooks';
import { useVarietiesByCustomer } from '../../../services/entities/hooks/useVarietiesByCustomer';
import { Block } from '../../../services/entities/impl/blfApi/schemas/block';
import { CropType } from '../../../services/entities/impl/blfApi/schemas/variety';
import { setCropTypesOfFilteredBlocks } from '../../select/selectSlice';

/**
 * Hook to get crop types of filtered blocks and set it in redux.
 * Used for things like determining which ranch summary table to display.
 * In the future, we will likely use this to create a new crop type selector in the navbar.
 * @param blocks Block[] - Filtered blocks to get crop types from
 * @param customerId string - Customer ID to fetch varieties for
 */
const useGetCropTypesOfFilteredBlocks = (
  blocks: Block[] | undefined,
  customerId: string | undefined
) => {
  const dispatch = useAppDispatch();

  // Fetch varieties for the customer
  const { getVariety } = useVarietiesByCustomer(customerId);

  useEffect(() => {
    const cropTypes = new Set<CropType>();

    if (!blocks) {
      dispatch(setCropTypesOfFilteredBlocks([]));
      return;
    }

    blocks.forEach((block) => {
      const variety = getVariety(block.varietyID);
      if (variety?.cropType) {
        cropTypes.add(variety.cropType);
      }
    });

    dispatch(setCropTypesOfFilteredBlocks(Array.from(cropTypes)));
  }, [blocks, getVariety, dispatch]);
};

export default useGetCropTypesOfFilteredBlocks;
